import { useLayoutEffect } from "react";
import { Navbar, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function Navigation() {
  const stickyNav = () => {
    const navbar = document.querySelector(".sticky-top");

    if (window.pageYOffset > 75) {
      navbar.style.top = "0px";
    } else {
      navbar.style.top = "-100px";
    }
  };

  useLayoutEffect(() => {
    window.onscroll = function () {
      stickyNav();
    };
  }, []);
  return (
    <Navbar bsPrefix="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
      <NavLink
        to="/"
        className="navbar-brand d-flex align-items-center text-center py-0 px-4 px-lg-5"
      >
        <h1 className="m-0 text-primary">
          {process.env.REACT_APP_JOB_PORTAL_NAME}
        </h1>
      </NavLink>
      <Navbar.Toggle
        aria-controls="navbarCollapse"
        bsPrefix="navbar-toggler me-4"
      >
        <span className="navbar-toggler-icon"></span>
      </Navbar.Toggle>
      <Navbar.Collapse id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">
          <NavLink
            to="/"
            className={({ isActive }) =>
              "nav-item nav-link" + (isActive ? " active" : "")
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              "nav-item nav-link" + (isActive ? " active" : "")
            }
          >
            About
          </NavLink>
          <NavDropdown
            title="JOBS"
            id="basic-nav-dropdown"
            bsPrefix="nav-item dropdown d-lg-none"
          >
            <NavLink
              to="/job-list"
              className={({ isActive }) =>
                "dropdown-item" + (isActive ? " active" : "")
              }
            >
              Job List
            </NavLink>
          </NavDropdown>
          <div className="nav-item dropdown d-none d-lg-block">
            <button
              className="nav-link dropdown-toggle mr-0"
              data-bs-toggle="dropdown"
            >
              Jobs
            </button>
            <div className="dropdown-menu rounded-0 m-0">
              <NavLink
                to="/job-list"
                className={({ isActive }) =>
                  "dropdown-item" + (isActive ? " active" : "")
                }
              >
                Job List
              </NavLink>
            </div>
          </div>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              "nav-item nav-link" + (isActive ? " active" : "")
            }
          >
            Contact
          </NavLink>
          <NavLink
            to="/post-job"
            className={({ isActive }) =>
              "nav-item nav-link d-lg-none" + (isActive ? " active" : "")
            }
          >
            Post A Job
          </NavLink>
        </div>
        <NavLink
          to="/post-job"
          className="btn btn-primary rounded-0 py-4 px-lg-5 d-none d-lg-block"
        >
          Post A Job<i className="fa fa-arrow-right ms-3"></i>
        </NavLink>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;
